import React, { useState } from "react";
import { Redirect } from "react-router-dom";

import { Container, makeStyles, Paper, Typography } from "@material-ui/core";

import SwitchButton from "./SwitchButton";
import LiquidityDeployer from "./LiquidityDeployer";
import LiquidityRemover from "./RemoveLiquidity";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    maxWidth: 700,
    margin: "auto",
  },
  title: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  footer: {
    marginTop: "155px",
  },
}));

function Liquidity({ network }) {
  const classes = useStyles();

  const [deploy, setDeploy] = useState(true);

  const deploy_or_remove = (deploy) => {
    if (deploy === true) {
      return <LiquidityDeployer network={network} />;
    }
    return <LiquidityRemover network={network} />;
  };

  return (
    <>
      {network.chainID != 56 ? (
        <div>
          <Container>
            <Paper elevation={0} className={classes.paperContainer}>
              <Typography variant="h5" className={classes.title}>
                <SwitchButton deploy={deploy} setDeploy={setDeploy} />
              </Typography>

              {deploy_or_remove(deploy)}
            </Paper>
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

export default Liquidity;
